import { Controller } from "@hotwired/stimulus"

// Bandeau « Marquer comme lu » + avis utile en bas des articles (modale et pleine page).
export default class extends Controller {
  static values = {
    markAsReadUrl: String,
    unmarkAsReadUrl: String,
    recordHelpfulUrl: String,
    compact: Boolean,
    onboarding: Boolean,
    indexCardOptions: String
  }

  get requestContext() {
    const context = { compact: this.compactValue, onboarding: this.onboardingValue }
    const indexCardOptions = this.indexCardOptionsPayload
    if (indexCardOptions) {
      context.index_card_options = indexCardOptions
    }
    return context
  }

  get indexCardOptionsPayload() {
    if (this.hasIndexCardOptionsValue && this.indexCardOptionsValue) {
      return this.indexCardOptionsValue
    }

    return this.element.closest("turbo-frame")?.dataset?.academyArticleReaderIndexCardOptions || ""
  }

  markAsRead(event) {
    event.preventDefault()
    const button = event.currentTarget
    if (button.disabled) return

    button.disabled = true
    this.post(this.markAsReadUrlValue, this.requestContext)
      .catch(() => {
        button.disabled = false
      })
  }

  unmarkAsRead(event) {
    event.preventDefault()
    const button = event.currentTarget
    if (button.disabled) return

    button.disabled = true
    this.post(this.unmarkAsReadUrlValue, this.requestContext)
      .catch(() => {
        button.disabled = false
      })
  }

  recordHelpful(event) {
    event.preventDefault()
    const button = event.currentTarget
    const helpful = button.dataset.helpful === "true"
    const previousHelpful = this.currentHelpful()

    this.applyVoteState(helpful)

    this.post(this.recordHelpfulUrlValue, { helpful, ...this.requestContext })
      .catch(() => {
        this.applyVoteState(previousHelpful)
      })
  }

  currentHelpful() {
    const activeButton = this.element.querySelector(".academy-article-reading-footer__vote--active")
    if (!activeButton) return null

    return activeButton.dataset.helpful === "true"
  }

  applyVoteState(helpful) {
    this.voteButtons.forEach((voteButton) => {
      const positive = voteButton.dataset.helpful === "true"
      const active = helpful !== null && helpful === positive

      voteButton.classList.toggle("academy-article-reading-footer__vote--active", active)
      voteButton.setAttribute("aria-pressed", active)

      const icon = voteButton.querySelector("i")
      if (!icon) return

      icon.classList.toggle("far", !active)
      icon.classList.toggle("fas", active)
    })
  }

  get voteButtons() {
    return this.element.querySelectorAll(".academy-article-reading-footer__vote")
  }

  openSupportChat(event) {
    event.preventDefault()
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:open"])
    }
  }

  suggestArticle(event) {
    event.preventDefault()
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:open"])
      window.$crisp.push(["do", "message:send", ["text", "Suggestion d'article Académie : "]])
    }
  }

  post(url, body) {
    const headers = {
      Accept: "text/vnd.turbo-stream.html",
      "Content-Type": "application/json",
      "X-CSRF-Token": this.csrfToken
    }

    return fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
      credentials: "same-origin"
    }).then((response) => {
      if (!response.ok) throw new Error("request failed")
      return response.text()
    }).then((html) => {
      if (html.includes("turbo-stream")) {
        window.Turbo.renderStreamMessage(html)
      }

      if (url === this.unmarkAsReadUrlValue) {
        document.dispatchEvent(new CustomEvent("academy-article-reader:engagement-reset"))
      }
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
